"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var QUERY_MIN_TEMPLATE = exports.QUERY_MIN_TEMPLATE = "@media (min-width: #{minWidth})";
var QUERY_MAX_TEMPLATE = exports.QUERY_MAX_TEMPLATE = "@media (max-width: #{maxWidth})";
var QUERY_MIN_MAX_TEMPLATE = exports.QUERY_MIN_MAX_TEMPLATE = "@media (min-width: #{minWidth}) and (max-width: #{maxWidth})";

var QUERY_TEMPLATE = exports.QUERY_TEMPLATE = "#{query} {\n#{value}\n}";

var DECLARATION_TEMPLATE = exports.DECLARATION_TEMPLATE = "#{name}: #{value};";

var CSS_FUNCTION_TEMPLATE = exports.CSS_FUNCTION_TEMPLATE = "#{typeOfFunction}(#{value})";


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/const/templates.js
// module id = 654
// module chunks = 168707334958949